var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientVaultEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#EEF3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5142 12.8203H29.4886C18.8677 12.8203 10.2578 21.4302 10.2578 32.0511V67.9485C10.2578 78.5694 18.8677 87.1793 29.4886 87.1793H70.5142C81.1351 87.1793 89.745 78.5694 89.745 67.9485V32.0511C89.745 21.4302 81.1351 12.8203 70.5142 12.8203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5365 29.4883H38.4595C32.7951 29.4883 28.2031 34.0802 28.2031 39.7447V62.8216C28.2031 68.4861 32.7951 73.078 38.4595 73.078H61.5365C67.2009 73.078 71.7929 68.4861 71.7929 62.8216V39.7447C71.7929 34.0802 67.2009 29.4883 61.5365 29.4883Z",
    fill: "#4F7CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9994 62.8191C56.3719 62.8191 61.5379 57.6532 61.5379 51.2806C61.5379 44.9081 56.3719 39.7422 49.9994 39.7422C43.6269 39.7422 38.4609 44.9081 38.4609 51.2806C38.4609 57.6532 43.6269 62.8191 49.9994 62.8191Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53.75C51.3807 53.75 52.5 52.6307 52.5 51.25C52.5 49.8693 51.3807 48.75 50 48.75C48.6193 48.75 47.5 49.8693 47.5 51.25C47.5 52.6307 48.6193 53.75 50 53.75Z",
    fill: "#4F7CFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41.0234V46.1516",
    stroke: "#4F7CFF",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56.4102V61.5384",
    stroke: "#4F7CFF",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7422 51.2852H44.8704",
    stroke: "#4F7CFF",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.125 51.2852H60.2532",
    stroke: "#4F7CFF",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6431 79.4894C81.3076 79.4894 85.8995 74.8974 85.8995 69.233C85.8995 63.5685 81.3076 58.9766 75.6431 58.9766C69.9787 58.9766 65.3867 63.5685 65.3867 69.233C65.3867 74.8974 69.9787 79.4894 75.6431 79.4894Z",
    fill: "#F4F6FB",
    stroke: "#D9DFEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6399 74.358C78.4722 74.358 80.7681 72.062 80.7681 69.2298C80.7681 66.3975 78.4722 64.1016 75.6399 64.1016C72.8077 64.1016 70.5117 66.3975 70.5117 69.2298C70.5117 72.062 72.8077 74.358 75.6399 74.358Z",
    stroke: "#6B7895"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 66.25L78.75 72.5",
    stroke: "#6B7895",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientVaultEmptyState);
export default __webpack_public_path__ + "static/media/client_vault_empty_state.a6a2cd2a1110e167d29ccd09296d441b.svg";
export { ForwardRef as ReactComponent };